import React from 'react';
import PropTypes from 'prop-types';

const OpenScheduleDateOnly = ({
    label,
    month,
    isProviderMapPinView,
    showMobileMonthHeading,
}) => {

    return (
        <div className={"date-btn"}>
            {isProviderMapPinView && showMobileMonthHeading && <div className="pin-month-text"><span>{month}</span></div>}
            
            <div className={"btn btn-primary date-only-button"}>
                {label}
            </div>
        </div>
    );
}

OpenScheduleDateOnly.propTypes = {
    label: PropTypes.object,
    month: PropTypes.string,
    isProviderMapPinView: PropTypes.bool,
    showMobileMonthHeading: PropTypes.bool,
};

export default OpenScheduleDateOnly;